import {
    debugEvent,
    getAuthStorageSnapshot,
    isAuthDebugEnabled,
} from "./AuthDebug";

export const getInitialStoreState = () => {
    return {
        access_token: undefined,
        user_type: undefined,
        statusCode: 200,
    }
};

export function authReducer(state, action) {
    switch (action.type) {
        case 'access_token': {
            // Never log the token itself. Only record whether storage succeeded.
            window.localStorage.setItem('access_token', action.access_token || '');

            if (isAuthDebugEnabled()) {
                debugEvent('AUTH_REDUCER_ACCESS_TOKEN', {
                    tokenProvided: !!action.access_token,
                    tokenStored: !!window.localStorage.getItem('access_token'),
                    authStorage: getAuthStorageSnapshot(),
                });
            }

            return { ...state, access_token: action.access_token };
        }

        case 'user_type': {
            if (isAuthDebugEnabled()) {
                debugEvent('AUTH_REDUCER_USER_TYPE', {
                    userType: action.user_type || null,
                });
            }

            return { ...state, user_type: action.user_type };
        }

        case 'logout':
            window.localStorage.removeItem('access_token');

            if (isAuthDebugEnabled()) {
                debugEvent('AUTH_REDUCER_LOGOUT', {
                    authStorageAfterLogout: getAuthStorageSnapshot(),
                });
            }

            return { ...state, access_token: undefined, user_type: undefined };

        default:
            return { ...state };
    }
}
